import React, { FC, MouseEventHandler } from 'react'

import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { makeStyles } from '@material-ui/core/styles'

import { SwitchArrow } from 'src/ui/molecules/dashboard-table-icons'
import { COLOR_WHITE_SMOKE } from 'src/constants'


const ColumnMapping = {
  name: 'User',
  email: 'Email',
  role: 'Role',
}

const useStyles = makeStyles(theme => ({
  headerCell: {
    backgroundColor: `${COLOR_WHITE_SMOKE}`,
    borderBottom: '1px solid transparent',
    '& .MuiTableSortLabel-root': {
      padding: '0px 16px',
      whiteSpace: 'nowrap'
    }
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
}))

interface IListViewHeadProps {
  order: 'asc' | 'desc'
  orderBy: string
  headCells: string[]
  onRequestSort: (event: MouseEventHandler<HTMLDivElement>, property: string) => void
}

export const ListViewHead: FC<IListViewHeadProps> = ({
  order,
  orderBy,
  onRequestSort,
  headCells
}) => {
  const classes = useStyles()

  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {headCells.slice(0, 50).map(headCell => {
          if (headCell === '__typename') return null

          return (
            <TableCell
              className={classes.headerCell}
              key={headCell}
              onClick={createSortHandler(headCell)}
              padding='none'
              sortDirection={orderBy === headCell ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell}
                direction={orderBy === headCell ? order : 'asc'}
                IconComponent={() => (
                  <SwitchArrow
                    activeColor={orderBy === headCell}
                    order={order}
                  />
                )}
              >
                 {ColumnMapping[headCell]}
                {orderBy === headCell ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          )
        })}
        <TableCell  className={classes.headerCell}>
          <TableSortLabel active={false}>Edit</TableSortLabel>
        </TableCell>
        <TableCell  className={classes.headerCell}>
          <TableSortLabel active={false}>Delete</TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}
